module.exports = __webpack_public_path__ + "img/DLK.b0756a53.jpg";